module.exports = __webpack_public_path__ + "img/qq.59139384.svg";